import Vue from 'vue'
import VAd1  from './ad1'

export default VAd1




// WEBPACK FOOTER //
// ./src/components/index/mobile/ad1/index.js